import axios from 'axios'

const account_form = {
  namespaced: true,

  state() {
    return {
      data: {
        email: null,
        password: null,
        name: null,
        name_kana: null,
        is_supervisor: false,
        contact: null,
        office: null,
        department: null,
        use_two_step_authentication: false,
      },
      errors: {},
    };
  },

  getters: {
    parameters(state) {
      let data = {
        email: state.data.email,
        name: state.data.name,
        name_kana: state.data.name_kana,
        contact: state.data.contact,
        office: state.data.office,
        department: state.data.department,
        use_two_step_authentication: state.data.use_two_step_authentication,
      }
      if (state.data.password !== null) {
        data.password = state.data.password;
      }
      return data;
    },
  },

  mutations: {
    setData(state, data) {
      state.data.email = data.email;
      state.data.password = null;
      state.data.name = data.name;
      state.data.name_kana = data.name_kana;
      state.data.is_supervisor = data.is_supervisor;
      state.data.contact = data.contact;
      state.data.office = data.office;
      state.data.department = data.department;
      state.data.use_two_step_authentication = data.use_two_step_authentication;
      state.errors = {};
    },

    setErrors(state, errors) {
      state.errors = {...errors};
    },

    inputFormItem(state, payload) {
      if (state.data[payload.column] !== undefined) {
        state.data[payload.column] = payload.value;
      }
    },
  },

  actions: {
    load({commit}) {
      return new Promise((resolve, reject) => {
        axios.get('/api/brokers/me').then((response) => {
          commit('setData', response.data.data);
          resolve(true);
        }).catch(() => reject());
      });
    },

    update({getters, commit}) {
      return new Promise((resolve, reject) => {
        axios.put('/api/brokers/me', getters.parameters).then((response) => {
          commit('setData', response.data.data);
          commit('account/setData', response.data.data, {root: true});
          commit('setFlashMessage', {value: '更新しました'}, {root: true});
          resolve(true);
        }).catch((error) => {
          let handled = false;
          if (error.response.status === 422) {
            commit('setErrors', error.response.data.errors);
            handled = true;
          }
          reject({handled});
        });
      });
    },
  }
};

export default account_form;
